import React, { useEffect, useMemo, useState } from "react";
import { Button, Card, Table } from "antd";
import { useNavigate } from "react-router-dom";
import message from "../message";
import TopBoxes from "./TopBoxes";

export default function DashboardPage() {
  const [loading, setLoading] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [stats, setStats] = useState({
    employeeCount: 0,
    lineCount: 0,
    actCount: 0,
    recentEmployees: [],
  });
  const navigate = useNavigate();
  const baseUrl = process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:8080";
  const token = useMemo(() => localStorage.getItem("token"), []);

  const loadDashboard = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const resp = await fetch(`${baseUrl}/manager/dashboard`, {
        headers: token ? { token } : {},
      });
      const result = await resp.json();
      const { code, msg } = result || {};
      if (code) {
        message.toast(msg || "加载失败");
        return;
      }
      setStats({
        employeeCount: result?.data?.employeeCount ?? 0,
        lineCount: result?.data?.lineCount ?? 0,
        actCount: result?.data?.actCount ?? 0,
        recentEmployees: result?.data?.recentEmployees || [],
      });
    } catch (error) {
      message.toast("加载失败");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadDashboard();
  }, []);

  const handleRefresh = async () => {
    if (refreshing) return;
    setRefreshing(true);
    await new Promise((resolve) => {
      setTimeout(resolve, 800);
    });
    await loadDashboard();
    setRefreshing(false);
  };

  const columns = [
    { title: "员工ID", dataIndex: "id", key: "id", align: "center", width: 200 },
    { title: "账号", dataIndex: "account", key: "account", align: "center", width: 180 },
    { title: "添加时间", dataIndex: "createTime", key: "createTime", align: "center", width: 200 },
  ];
  return (
    <div className="dashboard-page" style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      <TopBoxes stats={stats} onReload={handleRefresh} refreshing={refreshing} />
      <Card
        title={
          <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
            <span
              style={{
                width: 3,
                height: 12,
                borderRadius: 2,
                background: "#94a3b8",
                display: "inline-block",
              }}
            />
            新增员工
          </span>
        }
        extra={
          <Button type="default" onClick={() => navigate("/users", { state: { openAdd: true } })}>
            +添加账号
          </Button>
        }
      >
        <Table
          rowKey="id"
          columns={columns}
          dataSource={stats.recentEmployees}
          loading={loading}
          bordered
          pagination={false}
          scroll={{ x: 640 }}
        />
      </Card>
    </div>
  );
}
